import { render, staticRenderFns } from "./ContratoDespesa.vue?vue&type=template&id=47ac5ec8&"
import script from "./ContratoDespesa.vue?vue&type=script&lang=js&"
export * from "./ContratoDespesa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports